import { render } from "./BottomFooter.vue?vue&type=template&id=681bc000&lang=pug"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__